module.exports = __webpack_public_path__ + "fonts/Rubik-300-arabic7.6188414.woff2";